import { Component, Input, OnInit } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-header-section',
    templateUrl: './header-section.component.html',
    styleUrls: ['./header-section.component.scss']
})
export class HeaderSectionComponent implements OnInit {

    @Input() title      : string;
    @Input() buttonText?: string;
    @Input() buttonIcon?: string;
    @Input() buttonUrl? : string;

    public buttonIconName: IconName;

    constructor() { }

    ngOnInit(): void {

        this.buttonIconName = this.buttonIcon ? this.buttonIcon as IconName : null;

    }

}
